// importing the action types and a updateObject helper
import*as actionTypes from'../actions/actionTypes';var initialState={pageInfo:null};var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];// must return the same state or an updated version.
// example switch case to determine action. use immutable patterns for updating state.
switch(action.type){case actionTypes.OPEN_HELP:return Object.assign({},state,{pageInfo:action.pageInfo});case actionTypes.CLOSE_HELP:return Object.assign({},initialState);default:return Object.assign({},state);}};export default reducer;


//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/help.js
// module id = 1871
// module chunks = 29